import React, { useEffect, useState, useRef } from 'react'
import { VariableSizeList as List } from 'react-window'

import { ReportsRow, buildSetSize, getItemSize } from 'components/ReportsRow'
import {
  Card,
  CheckBox,
  Col,
  Grid,
  Input,
  Line,
  Row,
  Span,
  SimpleCard
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'
import { TypesReports } from 'utils/types'
import { useWindowResize } from 'hooks'

import { ContainerCard } from '.'
import { ListTypes } from '../ReportsAcess'

export interface IContractSupplier {
  contratos: TypesReports[]
  fornecedores: TypesReports[]
  getData: () => void
  handleChangeItem: (
    checked: boolean,
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas',
    id: number
  ) => void
  checkAll: (
    actionType: 'add' | 'remove' | 'checkAll' | 'unCheckAll',
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas',
    id?: number
  ) => void
  handleChangeInput: (value: string, t: ListTypes) => void
  contrato: string | undefined
  fornecedor: string | undefined
  disableAll?: boolean
}

const ContractSupplier: React.FC<IContractSupplier> = ({
  contratos,
  fornecedores,
  getData,
  handleChangeItem,
  checkAll,
  contrato,
  fornecedor,
  handleChangeInput,
  disableAll
}) => {
  const [allFornecedores, setAllFornecedores] = useState<boolean>(false)
  const [allContratos, setAllContratos] = useState<boolean>(false)

  useEffect(() => {
    if (disableAll) {
      setAllFornecedores(false)
      setAllContratos(false)
      disableAll = false
    }
  }, [allFornecedores, allContratos, disableAll])

  const contratosSizeMap = useRef({})
  const contratosListRef = useRef(null)
  const contratosSetSize = buildSetSize(contratosSizeMap, contratosListRef)

  const fornecedorSizeMap = useRef({})
  const fornecedorListRef = useRef(null)
  const fornecedorSetSize = buildSetSize(fornecedorSizeMap, fornecedorListRef)

  const [windowWidth] = useWindowResize()

  return (
    <>
      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Input
          label="Contrato"
          placeholder="Nº"
          value={contrato}
          onChange={(e) => handleChangeInput(e.target.value, 'contratos')}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
        />
        <Input
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          value={fornecedor}
          onChange={(e) => handleChangeInput(e.target.value, 'fornecedor')}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
        />
      </Grid>

      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Col>
          <Col>
            <Span text="Subcontratadas do Contrato" />
            <CheckBox
              checked={allContratos}
              label="Marcar Todos"
              onChange={(e) => {
                if (disableAll) setAllContratos(false)
                // eslint-disable-next-line no-unused-expressions
                e.target.checked
                  ? (setAllContratos(true), checkAll('checkAll', 'contrato'))
                  : (setAllContratos(false), checkAll('unCheckAll', 'contrato'))
              }}
              disabled={contratos?.length === 0}
            />
          </Col>

          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing15}
          >
            <Line />
            <List
              itemCount={contratos.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(contratosSizeMap, index)}
              ref={contratosListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={contratos[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={contratosSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'contrato',
                            contratos[index].id
                          )
                        }
                        checked={contratos[index].checked || false}
                        key={contratos[index].id}
                        label={contratos[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
        <Col marginTop={SPACING.spacing15}>
          <CheckBox
            label="Marcar Todos"
            checked={allFornecedores}
            onChange={(e) => {
              if (disableAll) setAllFornecedores(false)
              // eslint-disable-next-line no-unused-expressions
              e.target.checked
                ? (setAllFornecedores(true), checkAll('checkAll', 'fornecedor'))
                : (setAllFornecedores(false),
                  checkAll('unCheckAll', 'fornecedor'))
            }}
            disabled={fornecedores?.length === 0}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing15}
          >
            <Line />
            <List
              itemCount={fornecedores.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(fornecedorSizeMap, index)
              }
              ref={fornecedorListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={fornecedores[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={fornecedorSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'fornecedor',
                            fornecedores[index].id
                          )
                        }
                        checked={fornecedores[index].checked || false}
                        key={fornecedores[index].id}
                        label={fornecedores[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
      </Grid>
    </>
  )
}

export default ContractSupplier
